
import { UserItemProps } from "apis/user";
import axios from "axios";
import { OutputBaseProps } from "utils/types/API";
import { ApiFormAccessControllAllOutputProps } from ".";
import { AccessControllDataItemProps } from "layouts/admin/pages/permission/AccessControll/AccessControll";

interface R1 { type: "form"; formId: number };
interface R2 { type: "step"; formId: number; stepId: number }
interface R3 { type: "status"; formId: number; statusId: number }
type ApiFormAccessControllUserInputProps = R1 | R2 | R3;

type ApiFormAccessControllUserOutputProps = OutputBaseProps<UserItemProps[]>

export const apiFormAccessControllUser = async (data: ApiFormAccessControllUserInputProps) => {
    let url = "";
    switch (data.type) {
        case "form":
            url = `/api/form/${data.formId}/user/access-controll`;
            break;
        case "step":
            url = `/api/form/${data.formId}/step/${data.stepId}/user/access-controll`;
            break;
        case "status":
            url = `/api/form/${data.formId}/status/${data.statusId}/user/access-controll`;
            break;
        default:
            break;
    }
    const res = (await axios.get<ApiFormAccessControllUserOutputProps>(url)).data;
    return res;
};


type ApiFormAccessControllUserAllInputProps = { userId: number }

type ApiFormAccessControllUserAllOutputProps = ApiFormAccessControllAllOutputProps;

export const apiFormAccessControllUserAll = async (data: ApiFormAccessControllUserAllInputProps) => {
    const res = (await axios.get<ApiFormAccessControllUserAllOutputProps>(`/api/form/access-controll/user/${data.userId}`)).data;
    return res;
};

interface ApiFormAccessControllUserAllUpdateInputProps {
    userId: number;
    data: AccessControllDataItemProps[]
}
export const apiFormAccessControllUserAllUpdate = async (data: ApiFormAccessControllUserAllUpdateInputProps) => {
    const res = (await axios.put<ApiFormAccessControllUserAllOutputProps>(`/api/form/access-controll/user/update/${data.userId}`, data.data)).data;
    return res;
};
